<div class='grit-field-grid-container'>
  <div class="field-grid-wrapper" #gridWrapper><ng-content></ng-content></div>
</div>
<div class='grit-field-subscript-container'>
  <div class="field-subscript-wrapper" #subscriptWrapper>
    <ng-content
      select="pg-field-grid-subscript, grit-field-grid-subscript"
    ></ng-content>
  </div>
</div>
